
    <h1>인재상</h1>
    <div class="talent">
        <i data-aos="fade-down"></i>
    </div>
